export enum EnumTipoTchFij {
  NoEsTch,
  CargoFijo,
  CostoHorario
}

export enum EnumTipoTresPuntos {
  CF,
  Espera,
  Reserva,
  VA,
  Llantas,
  PzaEsp,
  Combustible,
  Lubricante,
  OtrasFEnergia
}
